import { OptionType } from '@evinced-private/ui-common';

interface IScanFilterOptions {
	scans?: OptionType[];
	allScans?: OptionType[];
}

export const resolveScanOptions = (
	data: IScanFilterOptions | undefined,
	includeScansWithoutIssues: boolean
): OptionType[] => {
	if (includeScansWithoutIssues && data?.allScans?.length) {
		return data.allScans;
	}
	return data?.scans ?? [];
};
